import { render, staticRenderFns } from "./giftdataviewxg.vue?vue&type=template&id=5630a2f4&scoped=true&"
import script from "./giftdataviewxg.vue?vue&type=script&lang=js&"
export * from "./giftdataviewxg.vue?vue&type=script&lang=js&"
import style0 from "./giftdataviewxg.vue?vue&type=style&index=0&id=5630a2f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5630a2f4",
  null
  
)

export default component.exports